import FieldProto from "../../../proto/field-proto"

import FieldConfig from "../../../proto/field-config"
import FieldTimeReportEntity_ViewGroup from "./render/group/group"
import FieldTimeReportEntity_TableCell from "./render/table-cell"
import GroupBy from "../../../../gd/manager/group-by/group-by-model"
import ItemModelV2 from "../../../../model2/item2/item-model"
import ModelEntity from "../../../../model2/model-entity"

export default class FieldTimeReportEntity extends FieldProto {

    constructor(config:FieldConfig) {
        super(config)

        this.icon           = "i5-work-items"
        this.label          = "Work item"
        this.description    = "Source type of the time report (Task, Meeting, or Generic)"

        this.renderComponents.viewGroup = FieldTimeReportEntity_ViewGroup
        this.renderComponents.tableCell = FieldTimeReportEntity_TableCell
    }

    groupValue(value: any, groupBy?: GroupBy) {
        if (!value) return null
        return value.rid
    }

    groupLabel(value: any, groupBy?:GroupBy): string {
        if (!value) return 'Not set'
        return value.name
    }

    groupItemValue(itemModel: ItemModelV2, groupBy: GroupBy): any {
        const value = _.get(itemModel.item, this.fieldId, null)
        if (!value) {
            return null
        }

        return value as ModelEntity //(value as ModelEntity).rid
    }

    sortValue(value: any): string {
        return value?.name?.toLowerCase() ?? ''
    }
}